module.exports = __webpack_public_path__ + "img/sf-icon.9cb58a1.webp";